import { ReadTagsAvailableToSetToDeviceRequest } from '@openapi';
import { getTagsApi } from './configuration';

const tags = {
  getDeviceTags: () => {
    return getTagsApi().readNumberOfDevicesForEachTag();
  },
  getGroupTags: () => {
    return getTagsApi().readTagsAvailableToSetToGroup();
  },
  getTags: (requestParameters: ReadTagsAvailableToSetToDeviceRequest['deviceId']) => {
    return getTagsApi().readTagsAvailableToSetToDevice({ deviceId: requestParameters });
  },
};

export default tags;
